import { InertiaLink } from "@inertiajs/inertia-react";
import Layout from "../../Shared/Layout";
import SelfRepairGuidesLayout from "./SelfRepairGuidesLayout";
import { Container } from "@material-ui/core";
import { Trans } from "../../utils/i18n";
import { usePage } from "@inertiajs/inertia-react";
import { isNil } from "lodash";

export default function SelfRepairGuidesIndexPage({ categories }) {
    const {
        recentGuides = [],
        popularGuides = [],
        stat1,
        stat2,
        stat3,
    } = usePage().props;

    return (
        <SelfRepairGuidesLayout
            // title={
            //     <Trans i18nKey="selfRepair.header.title">
            //         Self repair, don't replace. Your device, our Earth.
            //     </Trans>
            // }
            stats={[
                {
                    title: <Trans i18nKey="selfRepair.index.stat1" />,
                    count: stat1,
                },
                {
                    title: <Trans i18nKey="selfRepair.index.stat2" />,
                    count: stat2,
                },
                {
                    title: <Trans i18nKey="selfRepair.index.stat3" />,
                    count: stat3,
                },
            ].filter((stat) => !isNil(stat.count))}
            recentGuides={recentGuides}
            popularGuides={popularGuides}
        >
            <Container maxWidth="lg">
                <div className="flex flex-col items-center">
                    <h2 className="mt-0 leading-tight">
                        <Trans i18nKey="selfRepair.index.title" />
                    </h2>
                    {/* <p className="mt-0 leading-normal">
                        <Trans i18nKey="selfRepair.index.description" />
                    </p> */}

                    <div className="flex justify-center w-full">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
                            {categories.map((category) => (
                                <InertiaLink
                                    href={route(
                                        "selfrepair.guides.showCategory",
                                        {
                                            category: category.slug,
                                        }
                                    )}
                                    key={category.id}
                                    className="flex flex-col justify-center items-center gap-2 shadow-md p-4 rounded-md transform hover:scale-[1.02] transition-transform ease-in-out no-underline text-black"
                                >
                                    <img
                                        src={category.image}
                                        className="object-contain h-16 w-16 rounded-md shrink-0"
                                    />
                                    <div className="font-bold">{category.description}</div>
                                </InertiaLink>
                            ))}
                        </div>
                    </div>
                </div>
            </Container>
        </SelfRepairGuidesLayout>
    );
}

SelfRepairGuidesIndexPage.layout = (page) => (
    <Layout children={page} wrapperStyle={{ paddingTop: 0 }} />
);
